export interface IdValuePair {
    id: number;
    value: string;
}

export interface AssignmentEnums {
    type : IdValuePair[];
    status : IdValuePair[];
    source : IdValuePair[];
    assignor : IdValuePair[];
    errorCategory : IdValuePair[];
    access : IdValuePair[];
    contactRole : IdValuePair[];
    eventAction : IdValuePair[];
}

export enum AssignmentErrorCategoryEnum {
    Unset = 0,
    A = 1,
    B = 2,
    C = 3,
    A_3H = 4,
}